'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface QuickAccessTile {
  id: number;
  titleKey: string;
  descriptionKey: string;
  icon: string;
  link: string;
  color: string;
}

export default function QuickAccessTiles() {
  const { t } = useLanguage();
  
  const mockQuickAccessTiles: QuickAccessTile[] = [
    {
      id: 1,
      titleKey: 'home.quickAccess.products',
      descriptionKey: 'home.quickAccess.products.desc',
      icon: 'ShoppingBagIcon',
      link: '/products',
      color: 'bg-primary'
    },
    {
      id: 2,
      titleKey: 'home.quickAccess.production',
      descriptionKey: 'home.quickAccess.production.desc',
      icon: 'BuildingOfficeIcon',
      link: '/production',
      color: 'bg-secondary'
    },
    {
      id: 3,
      titleKey: 'home.quickAccess.wholesale',
      descriptionKey: 'home.quickAccess.wholesale.desc',
      icon: 'TruckIcon',
      link: '/wholesale',
      color: 'bg-accent'
    },
    {
      id: 4,
      titleKey: 'home.quickAccess.about',
      descriptionKey: 'home.quickAccess.about.desc',
      icon: 'InformationCircleIcon',
      link: '/about',
      color: 'bg-trust'
    }
  ];

  return (
    <section data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:55:4" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="55" data-component-file="QuickAccessTiles.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20lg%3Apy-24%20bg-background%22%7D" className="py-16 lg:py-24 bg-background">
      <div data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:56:6" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="56" data-component-file="QuickAccessTiles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="container mx-auto px-6 lg:px-12">
        <div data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:57:8" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="57" data-component-file="QuickAccessTiles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-12%22%7D" className="text-center mb-12">
          <h2 data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:58:10" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="58" data-component-file="QuickAccessTiles.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20lg%3Atext-5xl%20font-heading%20text-primary%20mb-4%22%7D" className="text-3xl lg:text-5xl font-heading text-primary mb-4">
            {t('home.quickAccess.title')}
          </h2>
          <p data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:61:10" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="61" data-component-file="QuickAccessTiles.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20lg%3Atext-xl%20text-muted-foreground%20max-w-2xl%20mx-auto%22%7D" className="text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('home.quickAccess.subtitle')}
          </p>
        </div>

        <div data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:66:8" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="66" data-component-file="QuickAccessTiles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {mockQuickAccessTiles.map((tile) => (
            <Link data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:68:12" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="68" data-component-file="QuickAccessTiles.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22group%20bg-card%20border%20border-border%20rounded-lg%20p-8%20hover%3Ashadow-warm-lg%20transition-all%20duration-brand%20hover%3A-translate-y-1%22%7D"
              key={tile.id}
              href={tile.link}
              className="group bg-card border border-border rounded-lg p-8 hover:shadow-warm-lg transition-all duration-brand hover:-translate-y-1"
            >
              <div data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:73:14" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="73" data-component-file="QuickAccessTiles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${tile.color} w-16 h-16 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-brand`}>
                <Icon data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:74:16" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="74" data-component-file="QuickAccessTiles.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={tile.icon as any} size={32} className="text-white" />
              </div>
              <h3 data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:76:14" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="76" data-component-file="QuickAccessTiles.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-xl%20font-heading%20text-foreground%20mb-3%20group-hover%3Atext-primary%20transition-colors%20duration-brand%22%7D" className="text-xl font-heading text-foreground mb-3 group-hover:text-primary transition-colors duration-brand">
                {t(tile.titleKey)}
              </h3>
              <p data-component-id="src/app/homepage/components/QuickAccessTiles.tsx:79:14" data-component-path="src/app/homepage/components/QuickAccessTiles.tsx" data-component-line="79" data-component-file="QuickAccessTiles.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%22%7D" className="text-muted-foreground">
                {t(tile.descriptionKey)}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}